import axios from 'axios';

import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { grey } from '@mui/material/colors';

import HeadLine2 from '../common/HeadLine2.js'
import BoxAroundTextField from '../common/BoxAroundTextField.js'
import YearPicker from '../common/YearPicker.js'
import StandardButton from '../common/StandardButton.js'
import copyTableToClipboard from '../utility/copyTableToClipboard.js'

export default function MonthSales(props) {
  const { token, salesMonth } = props;

  const [amount, setAmount] = useState([]);
  const [total, setTotal] = useState([]);
  // const [salesYear, setSalesYear] = useState(new Date(2024, 1));
  const [salesYear, setSalesYear] = React.useState(new Date(salesMonth));
  // const [startEnabledYear, setStartEnabledYear] = useState(new Date(2024, 1));
  // // const [endEnabledYear, setEndEnabledYear] = useState(new Date(2025, 1));
  // const [endEnabledYear, setEndEnabledYear] = useState(new Date(salesMonth));

  const FIXED_START_YEAR = 2020;
  const FIXED_END_YEAR   = 2026;

  const [startEnabledYear] = useState(new Date(FIXED_START_YEAR, 0, 1));
  const [endEnabledYear]   = useState(new Date(FIXED_END_YEAR, 11, 31));


  const [alertStatus, setAlertStatus] = useState({
    open: false,
    type: "success",
    message: ""
  });

  useEffect(() => {
    setAlertStatus({
      open: false,
      type: "close",
      message: ""
    });

    const year = String(new Date(salesYear).getFullYear());

    const apiURL = process.env.REACT_APP_BASEURL;
    const getURL = `${apiURL}/data_send/agency_sales_all_months?year=${year}`;

    // setBackdropOpen(true);

    axios({
      method: "GET",
      url:getURL,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(
        response => {

          console.log('rows:', response.data.rows);
          console.log('total:', response.data.total);


          // console.log(response.data.total);
          // console.log(response.data.rows);
          // console.log(response.data.first_year);
          // setAmount(response.data.rows)
          // setTotal(response.data.total)
          setAmount(Array.isArray(response.data.rows) ? response.data.rows : []);
          setTotal(Array.isArray(response.data.total) ? response.data.total : []);

          console.log('last_year(raw):', response.data.last_year);
          console.log('endEnabledYear(before):', endEnabledYear);
          const end = new Date(response.data.last_year, 1);
          console.log('endEnabledYear(new):', end, 'year=', end.getFullYear());
          
          // setStartEnabledYear(new Date(response.data.first_year, 1))
          // setEndEnabledYear(new Date(response.data.last_year, 1))


        }).catch((error) => {
          // setBackdropOpen(false)
          console.log('axios error')

          if (error.response) {
            setAlertStatus({
              open: true,
              type: "error",
              message: `接続エラー(${error.response.status})`
            });
          } else {
            setAlertStatus({
              open: true,
              type: "error",
              message: `エラー(${error})`
            });
          }
        }
        );
  }, [salesYear])


  return(
    <Box sx={{ p: 4 }}>
      <HeadLine2>
        ■ 月ごと売上
      </HeadLine2>
      <BoxAroundTextField>
        <YearPicker
          value={salesYear}
          minDate={startEnabledYear}
          maxDate={endEnabledYear}
          onChange={(newValue) => {
            console.log(newValue);
            setSalesYear(newValue);
          }}
        />
      </BoxAroundTextField>

      <StandardButton variant="contained" color="primary" onClick={() => copyTableToClipboard('monthly-table')}>
        クリップボードにコピー
      </StandardButton>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table id='monthly-table's>
          <TableHead>
            <TableRow>
              <TableCell>名前</TableCell>
              <TableCell>薬名</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>1</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>2</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>3</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>4</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>5</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>6</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>7</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>8</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>9</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>10</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>11</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>12</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {amount.map((row) => (
              <>
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.product_name}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['1']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['2']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['3']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['4']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['5']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['6']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['7']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['8']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['9']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['10']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['11']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['12']}</TableCell>
              </TableRow>

              </>
            ))}
            {total.map((row) => (
              <>
                <TableRow key={200}>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.product_name}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['1']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['2']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['3']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['4']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['5']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['6']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['7']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['8']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['9']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['10']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row['11']}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row['12']}</TableCell>
                </TableRow>

              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}